module.exports = __webpack_public_path__ + "assets/chevronLeft-136d0b.svg";